export function getConfiguredGoogleMapID() {
  const mapID = process.env.EXPO_PUBLIC_GOOGLE_MAPS_MAP_ID?.trim();
  return mapID ? mapID : undefined;
}
